import React from 'react';
import { Layout, Avatar, Dropdown, Space, Typography, Button } from 'antd';
import { UserOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../store/slices/authSlice';
import { RootState, AppDispatch } from '../../../store';
import { HeaderContainer, UserSection, UserInfo } from './Header.styles';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Mon Profil',
      onClick: () => navigate('/profile'),
    },
    
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Déconnexion',
      onClick: handleLogout,
    },
  ];

  return (
    <HeaderContainer>
      <div style={{ display: 'flex', alignItems: 'center',justifyContent: 'space-between', height: '100%' }}>
        <h3>TinsaFlow</h3>
        <div style={{ marginLeft: 'auto' }}>
          <UserSection>
            <Dropdown menu={{ items: menuItems }} placement="bottomRight">
              <Space>
                <UserInfo>
                  <Text strong>{user?.first_name} {user?.last_name}</Text>
                  <Text type="secondary" style={{ fontSize: '12px' }}>
                    {user?.role} {user?.mfa_enabled && '🔒'}
                  </Text>
                </UserInfo>
                <Avatar icon={<UserOutlined />} />
              </Space>
            </Dropdown>
          </UserSection>
        </div>
      </div>
    </HeaderContainer>
  );
};

export default Header;